import { z } from 'zod'

export const NewZipLeadType = {
  Buyer: 'buyer',
} as const

export const NewZipMilitaryStatus = {
  Yes: 'yes',
  No: 'no',
  Veteran: 'veteran',
} as const

export type NewZipMilitaryStatusValue =
  (typeof NewZipMilitaryStatus)[keyof typeof NewZipMilitaryStatus]

export const newZipSubmitPayloadSchema = z.object({
  type: z.literal(NewZipLeadType.Buyer),
  live: z.boolean(),
  ref: z.string().optional(),
  data: z.object({
    firstname: z.string().min(1),
    lastname: z.string().min(1),
    email: z.string().email(),
    phone: z.string().min(1),
    location: z.string().min(1),
    budget: z.number().positive(),
    message: z.string().optional(),
    preapproved: z.boolean().optional(),
    custom: z.object({
      loan_officer_name: z.string().min(1),
      loan_officer_email: z.string().email(),
      loan_officer_phone: z.string().min(1),
      prequalified: z.boolean().optional(),
      down_payment: z.number().positive().optional(),
      military_status: z
        .enum([
          NewZipMilitaryStatus.Yes,
          NewZipMilitaryStatus.No,
          NewZipMilitaryStatus.Veteran,
        ])
        .optional(),
      loan_type: z.string().optional(),
    }),
  }),
})

export type NewZipSubmitPayload = z.infer<typeof newZipSubmitPayloadSchema>

export const NewZipMissingField = {
  FirstName: 'firstName',
  LastName: 'lastName',
  Email: 'email',
  Phone: 'phone',
  Location: 'location',
  Budget: 'budget',
  LoanOfficer: 'loanOfficer',
  LoanOfficerName: 'loanOfficerName',
  LoanOfficerEmail: 'loanOfficerEmail',
  LoanOfficerPhone: 'loanOfficerPhone',
} as const

export type NewZipMissingFieldValue =
  (typeof NewZipMissingField)[keyof typeof NewZipMissingField]

export const NewZipMissingFieldLabel: Record<NewZipMissingFieldValue, string> =
  {
    [NewZipMissingField.FirstName]: 'First Name',
    [NewZipMissingField.LastName]: 'Last Name',
    [NewZipMissingField.Email]: 'Email',
    [NewZipMissingField.Phone]: 'Phone',
    [NewZipMissingField.Location]:
      'Borrower or Property Address (City/State or ZIP)',
    [NewZipMissingField.Budget]: 'Purchase Price',
    [NewZipMissingField.LoanOfficer]: 'Loan Officer',
    [NewZipMissingField.LoanOfficerName]: 'Loan Officer Name',
    [NewZipMissingField.LoanOfficerEmail]: 'Loan Officer Email',
    [NewZipMissingField.LoanOfficerPhone]: 'Loan Officer Phone',
  }
